module.exports = __webpack_public_path__ + "img/impressionen_plaetze.a505a80a.jpg";